module.exports = __webpack_public_path__ + "b02fd5c23b3e0d07bfe6b503674faa4d.pdf";